import { useTranslation } from 'react-i18next'
import { FieldDropdown } from '@/components/form'
import getPriceDateOptions, { getWeeklyPriceDateOptions } from '@/utils/price-date-options'

const PriceDateDescriptionField = ({ data }) => {
  const { t } = useTranslation()
  const isMonthlyPrice = data.price_frequency === 'monthly'
  const hideField = data.price_frequency === 'daily' || data.price_frequency === 'one_time'

  if (hideField) return null

  return (
    <FieldDropdown
      name="price_date_description"
      placeholder={t(`l.contract.edit.price_date_description.label`)}
      required
      options={isMonthlyPrice ? getPriceDateOptions(t) : getWeeklyPriceDateOptions(t)}
    />
  )
}

export default PriceDateDescriptionField
